module.exports = __webpack_public_path__ + "img/exclamation-circle-fill.717c940e.svg";